import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import { getAssetParts } from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsAssetPartsLoading: (isLoading: boolean) => void;
	setAssetPartsError: (err: string) => void;
};

export const useSearchAssetParts = ({
	setIsAssetPartsLoading,
	setAssetPartsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetParts },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setIsAssetPartsLoading(true);
		setListAssetParts([]);
		const res = await getAssetParts(assetSearchId, includeDescendants);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAssetParts(rowsSource);
			setIsAssetPartsLoading(false);
		} else {
			setAssetPartsError(res.message);
			setIsAssetPartsLoading(false);
		}
	};
};
